import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = { class: "flex flex-col gap-2" }

import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogClose,
        DialogFooter,
        DialogTrigger,
        DialogBody,
    } from '@/components/ui/dialog';
    import { ChevronRight } from 'lucide-vue-next';
    import { computed, ref } from 'vue';
    import { DatePicker } from '@/components/ui/form';
    import { getLocalTimeZone, today, endOfMonth, startOfMonth } from '@internationalized/date';
    import { Label } from '@/components/ui/label';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { useMutation } from '@tanstack/vue-query';
    import { usePage } from '@inertiajs/vue3';
    import axios from 'axios';
    import type { SharedData } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ExportEmployeesChanges',
  setup(__props) {

    const { t } = useI18n();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const open = ref(false);

    const handleClose = () => {
        open.value = false;
    };

    const currentDate = today(getLocalTimeZone());
    const startDate = ref(startOfMonth(currentDate));
    const endDate = ref(endOfMonth(currentDate));

    const { mutate, isPending } = useMutation({
        mutationFn: (formData: { from: string; to: string }) =>
            axios.get(route('v2.salary.employees.changes.export', selectedCompanyId.value), {
                params: formData,
            }),
        onSuccess: (response) => {
            if (response.data.no_changes !== undefined) {
                toast.success(response.data.no_changes);
            } else {
                document.location.href = response.request.responseURL;
            }
            open.value = false;
        },
        onError: (error: any) => {
            toast.error(t('forms.system_error'));
        },
    });

    function exportChanges() {
        mutate({
            from: startDate.value.toString(),
            to: endDate.value.toString(),
        });
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: open.value,
    "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((open).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost_primary",
            size: "xs",
            width: "narrow"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('employee.changes.export')) + " ", 1),
              _createVNode(_unref(ChevronRight), { class: "text-primary" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.export_all_changes_title')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogBody), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(Label), { for: "startDate" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('forms.from')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DatePicker), {
                    modelValue: startDate.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(Label), { for: "endDate" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('forms.to')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DatePicker), {
                    modelValue: endDate.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endDate).value = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogClose), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    size: "sm",
                    onClick: handleClose
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('forms.close')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                disabled: _unref(isPending),
                loading: _unref(isPending),
                size: "sm",
                onClick: exportChanges
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('employee.changes.export')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})